/* eslint-disable react/state-in-constructor */
import { Component } from 'react'
import { connect } from 'react-redux'
import { layoutNameFromWidth } from '@chegg-wt/core/utils/adframe'
import { adzoneSBMSelector, adLayoutSelector } from '@chegg-wt/core/state/app/selectors'
import { setAdLayoutName } from '@chegg-wt/core/state/app/actions'
import { Dispatch } from 'redux'
import { State } from './types'

const viewport = typeof window !== 'undefined' ? window : { innerWidth: 0 }

export interface Props {
  setAdLayout: (string) => void
  renderAds: any
  adzone: string
  adLayout: string
}

export class ResponsiveAdStrategy extends Component<Props, State> {
  state: State = {
    adReloadType: 'pagechange',
  }

  currentSizeTimeout = undefined

  componentDidMount() {
    window.addEventListener('resize', this.viewportSizeHandler)
  }

  shouldComponentUpdate(nextProps) {
    const { adLayout } = this.props
    return adLayout !== nextProps.adLayout
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.viewportSizeHandler)
    clearTimeout(this.currentSizeTimeout)
  }

  viewportSizeHandler = () => {
    if (this.currentSizeTimeout) clearTimeout(this.currentSizeTimeout)
    this.currentSizeTimeout = setTimeout(this.updateAdLayout, 300)
  }

  updateAdLayout = () => {
    const adLayout = layoutNameFromWidth(viewport.innerWidth)
    const { setAdLayout } = this.props
    setAdLayout(adLayout)
  }

  render() {
    if (typeof window !== 'undefined' && !window.hardPageload) {
      const { adReloadType } = this.state
      const { renderAds, adzone, adLayout } = this.props
      renderAds(adzone, adReloadType, adLayout)
    }

    return null
  }
}

const mapStateToProps = (state) => ({
  adzone: adzoneSBMSelector(state),
  adLayout: adLayoutSelector(state),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setAdLayout: (layoutName) => dispatch(setAdLayoutName(layoutName)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveAdStrategy)
